import { printLine, parseStyledString } from "../utilities.js";
import { screen } from "../screen.js";

export const program = {
    name: "dss solutions",
    size: 23, // Number of lines of this 'program'
    list: async () => {
        await printLine("6 SYS 2341"); // Simulate the 'list' command when this program is loaded
    }, 
    run: async () => {
        await screen.clearScreen();
        await printLine();
        await printLine(parseStyledString("[fg=white]***[/] [fg=yellow]WELCOME TO DSS SOLUTIONS[/] [fg=white]***[/]"), { align: 'center' });
        await printLine();
        await printLine("THIS SITE TRIES TO EMULATE A C64", { align: 'center' });
        await printLine("USING ONLY JAVASCRIPT, HTML AND CSS", { align: 'center' });
        await printLine("FOR A FULL LIST OF COMMANDS", { align: 'center'});
        await printLine(parseStyledString("LOAD AND RUN THE [fg=white]HELP[/] PROGRAM"), { align: 'center' });
        await printLine();
        await printLine(parseStyledString("[fg=white]***[/] [fg=yellow]HAVE FUN![/] [fg=white]***[/]"), { align: 'center' });
        await printLine();
    }
};